
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'
import { useSearchParams } from "react-router-dom"

export const WorkMasterPageExportData = (props) => {
    const { ExcelData, name, searchName, RoleID } = props

    const [searchParams] = useSearchParams()
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <tr>
                    <th colSpan={9} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Navi Mumbai Municipal Corporation</th>
                </tr>
                <tr>
                    <th colSpan={9} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>WATER SUPPLY DEPARTMENT</th>
                </tr>
                {
                    (DashProjectTypeId == '6' && RoleID != '16') ?
                        <tr>
                            <th colSpan={9} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - Distribution Line - Morbe Dam to Digha</th>
                        </tr>
                        :
                        <tr>
                            <th colSpan={9} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - Main Feeder - Morbe Dam to Digha</th>
                        </tr>
                }
                <tr>
                    <th colSpan={9} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Report Name: {name}</th>
                </tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th>Work Type</th>
                        <th>Work Period</th>
                        <th>Work Code</th>
                        <th width={800}>Work Name</th>
                        <th>Penalty Period</th>
                        <th>Bench Mark</th>
                        <th>Penalty Description</th>
                        <th style={{ borderRight: "1px solid black" }}>Penalty Amount (Rs.)</th>

                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr style={{ width: "100%", border: "1px solid black" }}>
                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.workType ? item.workType : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.workCode ? item.workCode : '-'}</td>
                                    <td style={{ textAlign: "left" }}>{item.workName ? item.workName : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.penaltyPeriod ? item.penaltyPeriod : '-'}</td>
                                    <td style={{ textAlign: "left" }}>{item.benchMark ? item.benchMark : '-'}</td>
                                    <td style={{ textAlign: "left" }}>{item.penalty_Description ? item.penalty_Description : '-'}</td>
                                    <td style={{ textAlign: "right" }}>{item.penalty_Values ? item.penalty_Values : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>

            </table>
        </div>
    )
}